import React from 'react'

import classNames from 'classnames'

import { Icon } from '@/Atomic/Atoms/Icon'

import './Breadcrumbs.scss'

export interface BreadcrumbsProps {
  children: React.ReactNode
  className?: string
  ariaLabel?: string
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  children,
  className,
  ariaLabel = 'breadcrumb',
}) => {
  const filteredItems = React.Children.toArray(children).filter(Boolean)

  if (filteredItems.length === 0) return null

  return (
    <nav
      aria-label={ariaLabel}
      className={classNames('m-breadcrumbs', className)}
    >
      <ol className="m-breadcrumbs-list">
        {filteredItems.map((child, index) => (
          <li
            className="m-breadcrumbs-item"
            key={(React.isValidElement(child) && child.key) || index}
          >
            {index > 0 && (
              <Icon
                icon="chevron-right"
                size="sm"
                className="m-breadcrumbs-separator"
              />
            )}
            {child}
          </li>
        ))}
      </ol>
    </nav>
  )
}
